export const Layout = ({ children }) => {
    return (
        <>
            <div className="grid place-items-center bg-blue-100 h-screen px-6 font-sans">
                <div className="fixed top-0 left-0 text-center w-full header bg-violet-600 py-4 text-white font-bold text-lg shadow-lg">
                    Simple Todo Application with Redux
                </div>
                {children}
            </div>
        </>
    );
};
